import { MusicTrack } from './types';

export function getMusicTrackVolume(track: MusicTrack): number {
  switch (track) {
    case 'menu':
      return 0.08;
    case 'gameplay':
      return 0.1;
    case 'victory':
      return 0.15;
    case 'gameover':
      return 0.12;
    default:
      return 0.1;
  }
}
